import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { filter } from 'lodash'
import axios from 'axios';
import { API_ENDPOINT_URL, SIGN_IN_API_ENDPOINT } from "../../constants/default";
import { InstantSearch, RefinementList, Configure, PoweredBy, Hits, SearchBox, Highlight, HitsPerPage, connectInfiniteHits, connectMenu } from 'react-instantsearch-dom';

// import Autocomplete from 'react-google-autocomplete';

class PickerChannelOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      long: '00.000',
      lat: '00.000',
      toResults: false,
      selectedChannels: [],
      userSelectedChannels: [],
      userSelectedChannelsIDs: [],
      dmaID: null,
      rsn: null,
      nullState: null,
      orgUUID: null,
      loading: false,
    }
  }

  handleButtonSubmit = (event) => {
    event.preventDefault();
    this.setState({ toResults: true });
  }

  goBack = () => {
    this.props.history.goBack();
  }

  handleAddChannel = (event) => {
    console.log('[CHOOSEN CHANNEL]', event.currentTarget.dataset.channelid);
    if(!this.state.userSelectedChannelsIDs.includes(event.currentTarget.dataset.channelid)) {
      var arrayAddition = {"id": event.currentTarget.dataset.channelid, "name": event.currentTarget.dataset.channelname}
      var idAddition = event.currentTarget.dataset.channelid
      this.setState({ 
        userSelectedChannels: [...this.state.userSelectedChannels, arrayAddition],
        userSelectedChannelsIDs: [...this.state.userSelectedChannelsIDs, idAddition]
      })
    }
  }

  showState = () => {
    console.log('[THIS STATE]', this.state);
  }

  handleRemoveChannel = (event) => {
    const { userSelectedChannels, userSelectedChannelsIDs } = this.state
    const itemId = event.currentTarget.dataset.itemid
    const channels = filter(userSelectedChannels, (item) => item.id !== itemId)
    const channelIds = filter(userSelectedChannelsIDs, (item) => item !== itemId)
    
    this.setState({
      userSelectedChannels: channels,
      userSelectedChannelsIDs: channelIds
    })
  }

  getDMACode = () => {
    // /dmas/lookup
    // TODO: move to redux
    this.setState({
      loading: true,
    });

    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjEsImlhdCI6MTUzNzgyMjgwMn0.9Fs54XoZ8F0FCBiWNJPW-9bqoZ_MMnxD4173nMPLft4'
    }

    var body = {
      "longitude": sessionStorage.getItem('long'),
      "latitude": sessionStorage.getItem('lat')
    }

    axios.post(`${API_ENDPOINT_URL}/dmas/lookup`, body, {
      headers
    }).then((res) => {
        console.log(res.data.dmaID)
        this.setState({
          dmaID: res.data.dmaID.toString(),
          rsn: res.data.rsn,
          loading: false,
        })
    }).catch((err) => {
        console.log(err)
        this.setState({
          loading: false,
        })
    })
  }

  componentDidMount = () => {
    const org_uuid = sessionStorage.getItem('org_uuid');
    // console.log(this.props.location.state)
    this.getDMACode();

    this.setState({
      orgUUID: org_uuid
    })
  }

  render() {
    if (this.state.toResults === true) {
      return <Redirect to={{pathname: '/picker/results', state: {chosenChannels: this.state.userSelectedChannelsIDs.toString()}}} />
    }

    const VirtualMenu = connectMenu(() => null);

    const Hit = ({ hit }) => {
      <HitsPerPage defaultRefinement={2} />
      return (
        <div className="hit" onClick={this.handleAddChannel} data-channelname={hit.name} data-channelid={hit.id}>
          <div>
            {hit.logo ? (
              <img src={hit.logo} alt="" />
            ) : (
              <p>{hit.name}</p>
            )}
          </div>
        </div>
      )
    }

    const CustomHits = connectInfiniteHits(({ hits, hasMore, refine }) => {
      return (<div className="ais-Hits"> <ul className="ais-Hits-list">
      {
        hits.map((hit, index) => {
          // console.log('[HIT]', hit)
          return <li className="ais-Hits-item" key={index}>
            <div className="hit" onClick={this.handleAddChannel} data-channelname={hit.name} data-channelid={hit.id}>
              <div>
                {hit.logo ? (
                  <img src={hit.logo} alt="" />
                ) : (
                  <p>{hit.name}</p>
                )}
              </div>
            </div>
          </li>
        })
      }
      </ul> </div>)
    });

    console.log('STATEHERE', this.state)
    return (
      <div>
        <div className="container mt-5">
          <div className="row mt-5 mb-5">
            <div className="col-md-12 mt-5">
              <a href="/" className="btn btn-success float-left">Go Back</a>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <h3>My Channels</h3>
              <div className="my-channel-list">
                {(this.state.userSelectedChannels.length > 0) ? (
                  <ul>
                    {this.state.userSelectedChannels.map((item, index) => {
                      return (
                        <li key={index} className="d-flex justify-content-between align-items-center">
                          {item.name} <i className="fal fa-times" onClick={this.handleRemoveChannel} data-itemid={item.id} data-itemtitle={item.name} data-itemindex={index} />
                        </li>
                      )
                    })}
                  </ul>                  
                ) : (
                  <p>No channels selected yet.</p>
                )}
              </div>
            </div>
            <div className="col-9">
              <h1 className="mb-3 text-left">Choose your channels</h1>
              <p className="text-left">Click on the channels that you are interested in. The 20 most popular channels are shown. Type in the search below to find more.</p>
              <InstantSearch
                appId="KZIMCQ20X3"
                apiKey="7efe6250c212970894cf85168ec9d426"
                indexName="channels"
              >
                {/*<RefinementList attribute="dma_code" />*/}
                <header className="header">
                  <SearchBox />
                </header>

                <main>
                  <Configure hitsPerPage={50} />

                  <VirtualMenu attribute="dma_code" defaultRefinement="not_set" />
                  <VirtualMenu attribute="dma_code" defaultRefinement={this.state.dmaID} />
                  <VirtualMenu attribute="rsns" defaultRefinement={this.state.rsn} />
                  <VirtualMenu attribute="rsns" defaultRefinement="not_set" />
                  <VirtualMenu attribute="organization_uuid" defaultRefinement="161b831d-c618-4303-8156-41a16baee81a" />
                  <VirtualMenu attribute="organization_uuid" defaultRefinement={this.state.orgUUID} />

                  <CustomHits />
                </main>
                {/* <PoweredBy className="mt-3" /> */}
              </InstantSearch>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {/* <button className="btn" onClick={this.showState}>show state</button> */}
              <a href="#" className="btn btn-primary continue-to-results" onClick={this.handleButtonSubmit}>Show my best options</a>
            </div>
          </div>
        </div>

        {this.state.loading ? (
          <div className="loading">
            <h3>Loading your channels...</h3>
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default connect()(PickerChannelOptions);



// WEBPACK FOOTER //
// ./src/components/Picker/PickerChannelOptions.js